import { ApiDataResponse } from '@frontend/jetlend-core/src/models/api';
import { ITestMetadata } from '@app/models/common/tests';
import { apiPostRequest } from '@app/services/client/api';

export async function apiPostTestSign(id: string): Promise<ApiDataResponse<ITestMetadata>> {
    /* testing:end */
    return apiPostRequest(`~/invest/api/tests/${id}/sign`, {});
    // return testPostResponse({ signed_url: '122' });
}
